import axios from 'axios';
import UserAuthKey from '../../../../components/Common/UserAuthKey';
import { setServiceItemList } from '../../../../Redux/services/serviceSlice';
import { setUserData } from '../../../../Redux/user/userSlice';

export const fetchAllItems = async ({ params, dispatch }) => {
  const apiUrl = process.env.REACT_APP_OMS_API;
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/services/item-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);

    dispatch(setServiceItemList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
    }
  }
};

export const createServiceItem = async ({ data, dispatch }) => {
  const apiUrl = process.env.REACT_APP_OMS_API;
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/services/item-create`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: data,
  };
  try {
    const response = await axios(config);
    await fetchAllItems({ params: {}, dispatch });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

export const updateServiceItem = async ({ id, data, dispatch }) => {
  const apiUrl = process.env.REACT_APP_OMS_API;
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/services/item-update`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      id,
      ...data,
    },
  };
  try {
    const response = await axios(config);
    await fetchAllItems({ params: {}, dispatch });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};

export const disableServiceItem = async ({ id, status, dispatch }) => {
  const apiUrl = process.env.REACT_APP_OMS_API;
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/services/item-status`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: { id: id, status: status },
  };
  try {
    const response = await axios(config);
    await fetchAllItems({ params: {}, dispatch });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};